import { render, staticRenderFns } from "./LiveBidsRightColumn.vue?vue&type=template&id=b81e2e12&scoped=true"
import script from "./LiveBidsRightColumn.vue?vue&type=script&lang=js"
export * from "./LiveBidsRightColumn.vue?vue&type=script&lang=js"
import style0 from "./LiveBidsRightColumn.vue?vue&type=style&index=0&id=b81e2e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81e2e12",
  null
  
)

export default component.exports